import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IChatMessage, MessageAuthor } from './VideoAssistantTypes';
import { VideoAiAssistantService } from './VideoAiAssistant.Service';

import styles from './VideoAiAssistantContainer.module.less';

@Component({
	selector: 'video-ai-assistant-user-message',
	template: `
		<div [ngClass]="[styles.flexRow, styles.message]">
			<vb-profile-picture [profileUrl]="user.profileImageUri" size="large"></vb-profile-picture>
			<div [ngClass]="styles.flexColumn">
				<div [ngClass]="styles.header">
					<span>{{ user.fullName }}</span>
					<span> - <i>{{ message.timestamp | vbDateTimeMedium }}</i></span>
				</div>
				<div [ngClass]="styles.messageContent">{{ message.content }}</div>
			</div>
		</div>
	`,

})
export class VideoAiAssistantUserMessageComponent {
	@Input() public user: any;
	@Input() public message: IChatMessage;
	@Output() public onTimeClicked: EventEmitter<number> = new EventEmitter<number>();

	public readonly styles = styles;
	public readonly MessageAuthor = MessageAuthor;

	constructor(
		public readonly VideoAiAssistantService: VideoAiAssistantService
	) { }

}
